// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <customer-loan-create-list-table
          customer-ids="[\$ctrl.customerId]"
          customer-type="\$ctrl.customerType"
          open-action="\$ctrl.open"
          creation-command="\$ctrl.creationCommand"
          loan-id="\$ctrl.loan.id"
          creation-type="\$ctrl.creationType">
  </customer-loan-create-list-table>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/new-loan/list/customer-loan-create-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;